import { render } from "./ModelsList.vue?vue&type=template&id=789e8b37"
import script from "./ModelsList.vue?vue&type=script&lang=js"
export * from "./ModelsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__